'use client';

import DynamicTitle from "@/components/elements/texts/DynamicTitle/DynamicTitle";
import DetailPagePagination from "@/components/objects/DetailPagePagination/DetailPagePagination";
import useFetchContentDetail from "@/hooks/useFetchContentDetail.hooks";
import parse from "html-react-parser";
import { redirect, useSearchParams } from "next/navigation";
import { Suspense, useEffect } from "react";
import { Meta } from "../../_configs/SiteInfo";
import { NewsDetailTemplateType } from "./NewsDetailTemplate.types";

const NewsDetailTemplate = (props: NewsDetailTemplateType) => {
  const {microCMSAuth, endpointId} = props;

  const searchParams = useSearchParams();
  const contentId = searchParams?.get("id") || "";
  const draftKey = searchParams?.get("draftKey") || '';

  if (!contentId) {
    redirect(`../`);
  }

  const microCMSQuery = {
    endpointId: endpointId,
    contentId: contentId,
    draftKey: draftKey
  };

  const {isLoading, response, hasError, errorMessage} = useFetchContentDetail(microCMSAuth, microCMSQuery);

  useEffect(() => {
    if (response) {
      document.title = response.title + " | " + Meta.siteName;
      document.querySelector('meta[name="description"]')?.setAttribute("content", response.title + " | " + Meta.siteName);
      const canonicalUrl = window.location.href;

      let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);
    }
  }, [response, searchParams, contentId, isLoading])

  if (isLoading) {
    return (
        <></>
    );
  };

  if (hasError) {
    return (
      <p style={{textAlign: "center"}}>{errorMessage}</p>
    );
  }
  return (
    <Suspense>
      {response ? (
        <>
          <DynamicTitle tag={"h2"} text={response.title} />
            <div className={"microcms-post"}>
              {parse(response.content)}
            </div>
            <DetailPagePagination
              microCMSAuth={microCMSAuth}
              endpointId={endpointId}
              contentId={contentId}
            />
        </>
      ) : null}
      </Suspense>
  )
}

export default NewsDetailTemplate;